import React from 'react';
import $ from "jquery";
import { Button } from 'semantic-ui-react';


import './style.css';
import View from './add';
import Upload from './upload';
import Title from '../../title';
import Loading from '../../loading';
import Server from '../../../functions/server';
import getFormatedDate from '../../../functions/date';
import Permission from '../../../functions/permission';
import ReadCookie from '../../../functions/readcookies';
import MakeDecimalPoints from '../../makedecimalpoints';

class Chitta extends React.Component {

  state = {
    fromDate: getFormatedDate(new Date(), 'fromDate'),
    toDate: getFormatedDate(new Date(), 'toDate'),
    chitta: [], menuPermission: []
  }

  componentDidMount() {
    this.getMenuControl();
  }

  getMenuControl() {
    let menuPermission = Permission('chitta', this.props.menus);
    if (menuPermission.view) {
      this.getChitta();
    }
    this.setState({ menuPermission })
  }

  getChitta() {
    let context = this;
    let data = (ReadCookie("branch"));
    let branchId;
    for (var i = 0; i < data.length; i++) {
      branchId = data[i].branch_id;
    }
    $.ajax({
      type: 'POST', data: { 'fromDate': context.state.fromDate, 'toDate': context.state.toDate, 'branchId': branchId },
      url: Server() + 'Accountings/Chitta/GetChitta.php',
      success: function(chitta) {
        try {
          chitta = JSON.parse(chitta);
          context.setState({ chitta })
        } catch (error) {
          alert('Try Again!!!');
        }
      },
      error: function(e) {
        context.setState({ load: false });
      }
    });
  }

  convertIntoNumber(value) {
    try {
      value = Number(value)
    } catch (error) {
      value = 0;
    }
    return value;
  }

  render() {
    let sino = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Title title={'Chitta'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div>
              <div style={{margin: '5px'}}>
                <div style={{display: 'flex'}}>
                  <div style={{marginLeft: '2px'}}>
                    From Date<br/>
                    <input type="date" value={this.state.fromDate} style={{width: '100%', height: 35 }}
                      onChange={ (event) => { this.setState({ fromDate: event.target.value }) }} />
                  </div>
                  <div style={{marginLeft: '2px'}}>
                    To Date<br/>
                    <input type="date" value={this.state.toDate} style={{width: '100%', height: 35 }}
                      onChange={ (event) => { this.setState({ toDate: event.target.value }) }} />
                  </div>
                  <div style={{marginLeft: '2px'}}>
                    <br/>
                    <Button onClick={this.getChitta.bind(this)}>Submit</Button>
                  </div>
                </div>
              </div>
              <div style={{margin: '5px'}}>
                <table id="table" width='100%'>
                  <tr id="th">
                    <th>Sino</th>
                    <th>Date</th>
                    <th>Opening Balance</th>
                    <th>Closing Balance</th>
                    <th>View</th>
                    <th>File</th>
                  </tr>
                  {
                    this.state.chitta.map((c) => {
                      let openingBalance = this.convertIntoNumber(c.opening_balance);
                      let closingBalance = this.convertIntoNumber(c.closing_balance);
                      closingBalance = openingBalance + closingBalance;
                      return (
                        <tr>
                          <td>{sino++}</td>
                          <td>{c.date}</td>
                          <td style={{textAlign: 'right'}}>{MakeDecimalPoints(openingBalance)}</td>
                          <td style={{textAlign: 'right'}}>{MakeDecimalPoints(openingBalance + (openingBalance - closingBalance))}</td>
                          <td><View date={c.date} /></td>
                          <td><center><Upload menuPermission={this.state.menuPermission} date={c.date} /></center></td>
                        </tr>
                      )
                    })
                  }
                </table>
              </div>
            </div>
          ):
          (
            <center>You ARe Not Allow To Access This Menu</center>
          )
        }
      </div>
    );
  }
}

export default Chitta;
